import { render, staticRenderFns } from "./SkillSimTreeItem.vue?vue&type=template&id=23ce3674&scoped=true&"
import script from "./SkillSimTreeItem.vue?vue&type=script&lang=ts&"
export * from "./SkillSimTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSimTreeItem.vue?vue&type=style&index=0&id=23ce3674&lang=less&scoped=true&"
import style1 from "./SkillSimTreeItem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce3674",
  null
  
)

export default component.exports